import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../app/api';

export const initialState = {
    workDaysByYear: {}, // { [year]: { workDays: [], loading, error, saveSuccess } }
    loading: false,
    error: null,
    saveSuccess: false
};

export const getAdminWorkDays = createAsyncThunk(
    'adminWorkDays/getAdminWorkDays',
    async (year, { rejectWithValue }) => {
        try {
            const response = await api.get(`/admin-work-days/${year}`);
            return { year, workDays: response.data };
        } catch (error) {
            return rejectWithValue({
                year,
                message: error.response?.data?.message || 'Грешка при зареждане на данните'
            });
        }
    }
);

export const saveAdminWorkDays = createAsyncThunk(
    'adminWorkDays/saveAdminWorkDays',
    async ({ year, workDays }, { rejectWithValue }) => {
        try {
            const response = await api.put('/admin-work-days', { year, workDays });
            return { year, workDays: response.data };
        } catch (error) {
            return rejectWithValue({
                year,
                message: error.response?.data?.message || 'Грешка при запазване на данните'
            });
        }
    }
);

const adminWorkDaysSlice = createSlice({
    name: 'adminWorkDays',
    initialState,
    reducers: {
        workDaysChanged: (state, action) => {
            const { year, workDays } = action.payload;
            if (!state.workDaysByYear[year]) {
                state.workDaysByYear[year] = { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
            }
            state.workDaysByYear[year].workDays = workDays;
        },
        clearSaveSuccess: (state, action) => {
            const year = action.payload;
            if (state.workDaysByYear[year]) {
                state.workDaysByYear[year].saveSuccess = false;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminWorkDays.pending, (state, action) => {
                const year = action.meta.arg;
                if (!state.workDaysByYear[year]) {
                    state.workDaysByYear[year] = { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
                }
                state.workDaysByYear[year].loading = true;
                state.workDaysByYear[year].error = null;
            })
            .addCase(getAdminWorkDays.fulfilled, (state, action) => {
                const { year, workDays } = action.payload;
                state.workDaysByYear[year] = {
                    ...state.workDaysByYear[year],
                    workDays,
                    loading: false,
                    error: null
                };
            })
            .addCase(getAdminWorkDays.rejected, (state, action) => {
                const { year, message } = action.payload || {};
                if (year) {
                    if (!state.workDaysByYear[year]) {
                        state.workDaysByYear[year] = { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
                    }
                    state.workDaysByYear[year].loading = false;
                    state.workDaysByYear[year].error = message;
                }
            })
            .addCase(saveAdminWorkDays.pending, (state, action) => {
                const year = action.meta.arg.year;
                if (!state.workDaysByYear[year]) {
                    state.workDaysByYear[year] = { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
                }
                state.workDaysByYear[year].loading = true;
                state.workDaysByYear[year].error = null;
                state.workDaysByYear[year].saveSuccess = false;
            })
            .addCase(saveAdminWorkDays.fulfilled, (state, action) => {
                const { year, workDays } = action.payload;
                state.workDaysByYear[year] = {
                    ...state.workDaysByYear[year],
                    workDays,
                    loading: false,
                    error: null,
                    saveSuccess: true
                };
            })
            .addCase(saveAdminWorkDays.rejected, (state, action) => {
                const { year, message } = action.payload || {};
                if (year) {
                    if (!state.workDaysByYear[year]) {
                        state.workDaysByYear[year] = { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
                    }
                    state.workDaysByYear[year].loading = false;
                    state.workDaysByYear[year].saveSuccess = false;
                    state.workDaysByYear[year].error = message;
                }
            });
    }
});

// Selectors
export const selectWorkDaysByYear = (state, year) => {
    const adminWorkDays = state.adminWorkDays || {};
    const workDaysByYear = adminWorkDays.workDaysByYear || {};
    return workDaysByYear[year] || { workDays: Array(12).fill(0), loading: false, error: null, saveSuccess: false };
};

export default adminWorkDaysSlice.reducer;
export const { workDaysChanged, clearSaveSuccess } = adminWorkDaysSlice.actions;